import type { ReactNode } from 'react';

// THE ONE LOOK A TABLE HAS IN THIS APP, taken from the Materials table: a white card with some
// room around the table, its title inside the card over the table, and every cell ruled on all
// four sides — so the table's outer edge is a line like its inner ones, and no side of it is
// left to the background.
//
// Styles as constants and not a <Table> component: the tables differ in everything but the
// look (sticky columns, spanned rows, rows that are switches), and a component general enough
// for all of them would be a second table API. The card is a component because it is the same
// markup every time.

// The rule every border is drawn in.
export const TABLE_RULE = 'border-slate-300';
// The table: collapsed borders, so neighbouring cells share one line rather than drawing two.
export const TABLE = 'w-full border-collapse text-center text-xs text-slate-700';
// A cell, ruled on every side.
export const TABLE_CELL = `border ${TABLE_RULE} px-2 py-1 align-middle`;
// A heading cell: the same rule, small capitals.
export const TABLE_HEAD =
  `${TABLE_CELL} text-[11px] font-bold uppercase tracking-wide text-slate-500`;

// A TABLE INSIDE A CELL — a material's surface numbers, a row's holes: black rules, snug. Its
// size and colour are the caller's, being the cell's own.
export const INNER_TABLE = 'mx-auto border-collapse whitespace-nowrap border border-black';
export const INNER_CELL = 'border border-black px-1 py-0.5 text-center';

// The title over a table, inside its card.
export function TableTitle({ children }: { children: ReactNode }) {
  return (
    <h5 className="mb-2 text-center text-[11px] font-bold uppercase tracking-wider text-slate-500">
      {children}
    </h5>
  );
}

// The card a table sits in, titled. `className` for the layout inside it (a gap, a column).
export function TableCard({ title, className = '', children }: {
  title?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={`mx-auto w-full rounded-2xl bg-white p-4 ${className}`}>
      {title && <TableTitle>{title}</TableTitle>}
      {children}
    </div>
  );
}
